import React from 'react'
//Helpers
import { getTitle } from '@helpers/helper.developments'
import { ElementHTML, getDescription } from '@helpers/helper.rendering'
import { Col, Container, Row } from 'react-bootstrap'
import useQueryDevelopment from '@hooks/useQueryDevelopment'
import { RealEstateDataPageComponentData } from 'types'

const AboutDevelopment_1 = ({
  developmentID,
  global_data,
  titleElement,
  button,
  is_short,
  title,
  subtitle,
  hidden,
}: { developmentID: string } & RealEstateDataPageComponentData) => {
  const icons = global_data.pageConfig.design.icons
  const iconsStyle = icons === 'Solid' || icons === 'Light' ? `-${icons.toLowerCase()}` : ''

  const { data: allDevelopmentData, isLoading } = useQueryDevelopment(
    developmentID,
    global_data.pageConfig.keys.tokko,
  )

  return (
    <section className={'ficha-about a p-y-config dev ' + (isLoading ? 'skeleton' : '')}>
      <div className="concepto">
        <Container fluid>
          {!is_short && getTitle(allDevelopmentData) && (
            <Row className={'intro ' + (hidden ? 'pb-0' : '')}>
              <Col>
                {button?.value && (
                  <button
                    data-bs-target={'#modal-social-' + developmentID}
                    className="mt-lg-0 mb-3 buton-share ms-auto d-none d-lg-none"
                  >
                    <i className={`me-lg-2 me-1 icon-share${iconsStyle}`}></i>
                    {button?.value}{' '}
                  </button>
                )}
                <Row className="align-items-center">
                  <Col lg={2}>
                    <ElementHTML
                      className="section-name"
                      elementType={titleElement || 'h4'}
                      children={subtitle || 'Concepto'}
                    />
                  </Col>
                  <Col
                    lg={10}
                    className="d-lg-flex justify-content-between align-items-center"
                  >
                    <p>{getTitle(allDevelopmentData)}</p>
                    {!is_short && button?.value && (
                      <button
                        data-bs-toggle="modal"
                        data-bs-target={'#modal-social-' + developmentID}
                        className="mt-lg-0 btn btn-primary buton-share d-none d-lg-block"
                      >
                        <i className={`me-lg-2 me-1 icon-share${iconsStyle}`}></i>
                        {button?.value}{' '}
                      </button>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </Container>
      </div>
      {!hidden && (
        <Container fluid>
          <Row className={'intro' + ' py-lg-0 pt-5 pb-0'}>
            <Col lg={2}>
              <ElementHTML
                className="section-name"
                elementType={titleElement || 'h4'}
                children={title || 'Descripción'}
              />
              {/* <h4 className="section-name">Descripción</h4> */}
            </Col>
            <Col
              className="d-lg-flex align-items-start"
              lg={10}
            >
              <p className="description-ficha">
                {getDescription(allDevelopmentData?.description, 99999).map(
                  (description, index) => (
                    <span key={index}>
                      {description}
                      <br />
                    </span>
                  ),
                )}
              </p>
              {(!getTitle(allDevelopmentData) || is_short) && button?.value && (
                <button
                  data-bs-toggle="modal"
                  data-bs-target={'#modal-social-' + developmentID}
                  className="mt-lg-0 btn btn-primary buton-share d-block d-lg-block"
                >
                  <i className={`me-lg-2 me-1 icon-share${iconsStyle}`}></i>
                  {button?.value}{' '}
                </button>
              )}
            </Col>
          </Row>
        </Container>
      )}
    </section>
  )
}

export default AboutDevelopment_1
